import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { bundleInfo, getProduct } from "@/lib/products";

const CartContext = createContext(null);
const KEY = "lumi_cart_v1";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v.filter((l) => getProduct(l.productId)) : [];
  } catch {
    return [];
  }
};

export function CartProvider({ children }) {
  const [lines, setLines] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(lines));
  }, [lines]);

  const clear = useCallback(() => setLines((prev) => (prev.length ? [] : prev)), []);

  const api = useMemo(() => {
    const add = (productId, shade, qty = 1) => {
      setLines((prev) => {
        const i = prev.findIndex((l) => l.productId === productId && l.shade === shade);
        if (i === -1) return [...prev, { productId, shade, qty }];
        const next = [...prev];
        next[i] = { ...next[i], qty: Math.min(20, next[i].qty + qty) };
        return next;
      });
      setOpen(true);
    };
    const setQty = (productId, shade, qty) =>
      setLines((prev) =>
        prev
          .map((l) => (l.productId === productId && l.shade === shade ? { ...l, qty: Math.min(20, qty) } : l))
          .filter((l) => l.qty > 0)
      );
    const count = lines.reduce((s, l) => s + l.qty, 0);
    const subtotal = lines.reduce((s, l) => s + (getProduct(l.productId)?.price ?? 0) * l.qty, 0);
    const bundle = bundleInfo(lines);
    const total = Math.round((subtotal - bundle.discount) * 100) / 100;
    return { lines, add, setQty, clear, count, subtotal, bundle, total, open, setOpen };
  }, [lines, open, clear]);

  return <CartContext.Provider value={api}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
